
(function () {
  'use strict';

  
  var sk = document.getElementById('stars');
  if (sk && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var out = '';
    for (var i = 0; i < 40; i++) {
      var x = (Math.random() * 100).toFixed(2),
          y = (Math.random() * 100).toFixed(2),
          d = (Math.random() * 4).toFixed(2),
          s = (Math.random() * 1.6 + 0.6).toFixed(1);
      out += '<span class="star" style="left:' + x + '%;top:' + y + '%;width:' + s + 'px;height:' + s + 'px;animation-delay:' + d + 's"></span>';
    }
    sk.innerHTML = out;
  }

  
  var els = document.querySelectorAll('.r');
  function revealNearViewport() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.classList.contains('v')) continue;
      if (el.getBoundingClientRect().top < vh * 0.95) el.classList.add('v');
    }
  }
  if ('IntersectionObserver' in window) {
    var o = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('v'); o.unobserve(e.target); }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { o.observe(el); });
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () { revealNearViewport(); ticking = false; });
      }
    }, { passive: true });
    revealNearViewport();
  } else {
    els.forEach(function (el) { el.classList.add('v'); });
  }

  
  document.querySelectorAll('a[href="#cena"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.getElementById('cena');
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  
  var bar = document.getElementById('sticky'),
      hero = document.querySelector('.hero'),
      price = document.getElementById('cena');
  if (bar && hero && price && 'IntersectionObserver' in window) {
    var heroGone = false, priceVisible = false;
    function upd() { bar.classList.toggle('show', heroGone && !priceVisible); }
    new IntersectionObserver(function (e) { heroGone = !e[0].isIntersecting; upd(); }).observe(hero);
    new IntersectionObserver(function (e) { priceVisible = e[0].isIntersecting; upd(); }, { threshold: 0.12 }).observe(price);
  }
})();
